import { render, staticRenderFns } from "./AnomalieIcon.vue?vue&type=template&id=4dec97e4"
import script from "./AnomalieIcon.vue?vue&type=script&lang=js"
export * from "./AnomalieIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports